/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPharmacies } from 'app/entities/pharmacy/pharmacy.reducer';
import { getEntities as getPharmacyConsumers } from 'app/entities/pharmacy-consumer/pharmacy-consumer.reducer';
import { getEntities as getGlucoUsers } from 'app/entities/gluco-user/gluco-user.reducer';
import { getEntities as getPharmacyBillPayments } from 'app/entities/pharmacy-bill-payment/pharmacy-bill-payment.reducer';
import { getEntities as getPharmacyRefundPayments } from 'app/entities/pharmacy-refund-payment/pharmacy-refund-payment.reducer';
import { getEntities as getPharmacySaleCredits } from 'app/entities/pharmacy-sale-credit/pharmacy-sale-credit.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getPharmacyBills } from 'app/entities/pharmacy-bill/pharmacy-bill.reducer';
import { CreditType } from 'app/shared/model/enumerations/credit-type.model';
import { ClosureStatus } from 'app/shared/model/enumerations/closure-status.model';
import { PharmacyAddedByType } from 'app/shared/model/enumerations/pharmacy-added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './pharmacy-sale-credit.reducer';

export const PharmacySaleCreditUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const pharmacies = useAppSelector(state => state.pharmacy.entities);
  const pharmacyConsumers = useAppSelector(state => state.pharmacyConsumer.entities);
  const glucoUsers = useAppSelector(state => state.glucoUser.entities);
  const pharmacyBillPayments = useAppSelector(state => state.pharmacyBillPayment.entities);
  const pharmacyRefundPayments = useAppSelector(state => state.pharmacyRefundPayment.entities);
  const pharmacySaleCredits = useAppSelector(state => state.pharmacySaleCredit.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const pharmacyBills = useAppSelector(state => state.pharmacyBill.entities);
  const pharmacySaleCreditEntity = useAppSelector(state => state.pharmacySaleCredit.entity);
  const loading = useAppSelector(state => state.pharmacySaleCredit.loading);
  const updating = useAppSelector(state => state.pharmacySaleCredit.updating);
  const updateSuccess = useAppSelector(state => state.pharmacySaleCredit.updateSuccess);
  const creditTypeValues = Object.keys(CreditType);
  const closureStatusValues = Object.keys(ClosureStatus);
  const pharmacyAddedByTypeValues = Object.keys(PharmacyAddedByType);

  const handleClose = () => {
    navigate(`/pharmacy-sale-credit${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPharmacies({}));
    dispatch(getPharmacyConsumers({}));
    dispatch(getGlucoUsers({}));
    dispatch(getPharmacyBillPayments({}));
    dispatch(getPharmacyRefundPayments({}));
    dispatch(getPharmacySaleCredits({}));
    dispatch(getClinicalDictionaries({}));
    dispatch(getPharmacyBills({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.totalAmount !== undefined && typeof values.totalAmount !== 'number') {
      values.totalAmount = Number(values.totalAmount);
    }
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }
    if (values.pendingAmount !== undefined && typeof values.pendingAmount !== 'number') {
      values.pendingAmount = Number(values.pendingAmount);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }

    const entity = {
      ...pharmacySaleCreditEntity,
      ...values,
      pharmacy: pharmacies.find(it => it.id.toString() === values.pharmacy?.toString()),
      consumer: pharmacyConsumers.find(it => it.id.toString() === values.consumer?.toString()),
      patient: glucoUsers.find(it => it.id.toString() === values.patient?.toString()),
      salePayment: pharmacyBillPayments.find(it => it.id.toString() === values.salePayment?.toString()),
      refundPayment: pharmacyRefundPayments.find(it => it.id.toString() === values.refundPayment?.toString()),
      amendedFrom: pharmacySaleCredits.find(it => it.id.toString() === values.amendedFrom?.toString()),
      amendedTo: pharmacySaleCredits.find(it => it.id.toString() === values.amendedTo?.toString()),
      invoiceType: clinicalDictionaries.find(it => it.id.toString() === values.invoiceType?.toString()),
      urType: clinicalDictionaries.find(it => it.id.toString() === values.urType?.toString()),
      saleBill: pharmacyBills.find(it => it.id.toString() === values.saleBill?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          creditType: 'IN',
          closureStatus: 'PENDING',
          addedByType: 'PHARMACY',
          modifiedByType: 'PHARMACY',
          ...pharmacySaleCreditEntity,
          pharmacy: pharmacySaleCreditEntity?.pharmacy?.id,
          consumer: pharmacySaleCreditEntity?.consumer?.id,
          patient: pharmacySaleCreditEntity?.patient?.id,
          salePayment: pharmacySaleCreditEntity?.salePayment?.id,
          refundPayment: pharmacySaleCreditEntity?.refundPayment?.id,
          amendedFrom: pharmacySaleCreditEntity?.amendedFrom?.id,
          amendedTo: pharmacySaleCreditEntity?.amendedTo?.id,
          invoiceType: pharmacySaleCreditEntity?.invoiceType?.id,
          urType: pharmacySaleCreditEntity?.urType?.id,
          saleBill: pharmacySaleCreditEntity?.saleBill?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.pharmacySaleCredit.home.createOrEditLabel" data-cy="PharmacySaleCreditCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.home.createOrEditLabel">
              Create or edit a PharmacySaleCredit
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="pharmacy-sale-credit-id"
                  label={translate('tinyMedicRestApp.pharmacySaleCredit.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.totalAmount')}
                id="pharmacy-sale-credit-totalAmount"
                name="totalAmount"
                data-cy="totalAmount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="totalAmountLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.totalAmount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.paidAmount')}
                id="pharmacy-sale-credit-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="paidAmountLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.paidAmount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.pendingAmount')}
                id="pharmacy-sale-credit-pendingAmount"
                name="pendingAmount"
                data-cy="pendingAmount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="pendingAmountLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.pendingAmount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.creditType')}
                id="pharmacy-sale-credit-creditType"
                name="creditType"
                data-cy="creditType"
                type="select"
              >
                {creditTypeValues.map(creditType => (
                  <option value={creditType} key={creditType}>
                    {translate(`tinyMedicRestApp.CreditType.${creditType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="creditTypeLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.creditType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.addedById')}
                id="pharmacy-sale-credit-addedById"
                name="addedById"
                data-cy="addedById"
                type="text"
              />
              <UncontrolledTooltip target="addedByIdLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.addedById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.modifiedById')}
                id="pharmacy-sale-credit-modifiedById"
                name="modifiedById"
                data-cy="modifiedById"
                type="text"
              />
              <UncontrolledTooltip target="modifiedByIdLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.modifiedById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.closureStatus')}
                id="pharmacy-sale-credit-closureStatus"
                name="closureStatus"
                data-cy="closureStatus"
                type="select"
              >
                {closureStatusValues.map(closureStatus => (
                  <option value={closureStatus} key={closureStatus}>
                    {translate(`tinyMedicRestApp.ClosureStatus.${closureStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="closureStatusLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.closureStatus" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.active')}
                id="pharmacy-sale-credit-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.cursor')}
                id="pharmacy-sale-credit-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.timestampentry')}
                id="pharmacy-sale-credit-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <UncontrolledTooltip target="timestampentryLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.timestampentry" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.microSec')}
                id="pharmacy-sale-credit-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.lastUpdated')}
                id="pharmacy-sale-credit-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.addedByType')}
                id="pharmacy-sale-credit-addedByType"
                name="addedByType"
                data-cy="addedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="addedByTypeLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.addedByType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.modifiedByType')}
                id="pharmacy-sale-credit-modifiedByType"
                name="modifiedByType"
                data-cy="modifiedByType"
                type="select"
              >
                {pharmacyAddedByTypeValues.map(pharmacyAddedByType => (
                  <option value={pharmacyAddedByType} key={pharmacyAddedByType}>
                    {translate(`tinyMedicRestApp.PharmacyAddedByType.${pharmacyAddedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="modifiedByTypeLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.modifiedByType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.cancelledReason')}
                id="pharmacy-sale-credit-cancelledReason"
                name="cancelledReason"
                data-cy="cancelledReason"
                type="text"
              />
              <UncontrolledTooltip target="cancelledReasonLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.cancelledReason" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.billNumber')}
                id="pharmacy-sale-credit-billNumber"
                name="billNumber"
                data-cy="billNumber"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <UncontrolledTooltip target="billNumberLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.billNumber" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.amended')}
                id="pharmacy-sale-credit-amended"
                name="amended"
                data-cy="amended"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="amendedLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.amended" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.pharmacySaleCredit.preGst')}
                id="pharmacy-sale-credit-preGst"
                name="preGst"
                data-cy="preGst"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="preGstLabel">
                <Translate contentKey="tinyMedicRestApp.pharmacySaleCredit.help.preGst" />
              </UncontrolledTooltip>
              <ValidatedField
                id="pharmacy-sale-credit-pharmacy"
                name="pharmacy"
                data-cy="pharmacy"
                label={translate('tinyMedicRestApp.pharmacySaleCredit.pharmacy')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacies
                  ? pharmacies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-consumer"
                name="consumer"
                data-cy="consumer"
                label={translate('tinyMedicRestApp.pharmacySaleCredit.consumer')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyConsumers
                  ? pharmacyConsumers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-patient"
                name="patient"
                data-cy="patient"
                label={translate('tinyMedicRestApp.pharmacySaleCredit.patient')}
                type="select"
              >
                <option value="" key="0" />
                {glucoUsers
                  ? glucoUsers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-salePayment"
                name="salePayment"
                data-cy="salePayment"
                label={translate('tinyMedicRestApp.pharmacySaleCredit.salePayment')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBillPayments
                  ? pharmacyBillPayments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-refundPayment"
                name="refundPayment"
                data-cy="refundPayment"
                label={translate('tinyMedicRestApp.pharmacySaleCredit.refundPayment')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyRefundPayments
                  ? pharmacyRefundPayments.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-amendedFrom"
                name="amendedFrom"
                data-cy="amendedFrom"
                label={translate('tinyMedicRestApp.pharmacySaleCredit.amendedFrom')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacySaleCredits
                  ? pharmacySaleCredits.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-amendedTo"
                name="amendedTo"
                data-cy="amendedTo"
                label={translate('tinyMedicRestApp.pharmacySaleCredit.amendedTo')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacySaleCredits
                  ? pharmacySaleCredits.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-invoiceType"
                name="invoiceType"
                data-cy="invoiceType"
                label={translate('tinyMedicRestApp.pharmacySaleCredit.invoiceType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-urType"
                name="urType"
                data-cy="urType"
                label={translate('tinyMedicRestApp.pharmacySaleCredit.urType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="pharmacy-sale-credit-saleBill"
                name="saleBill"
                data-cy="saleBill"
                label={translate('tinyMedicRestApp.pharmacySaleCredit.saleBill')}
                type="select"
              >
                <option value="" key="0" />
                {pharmacyBills
                  ? pharmacyBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/pharmacy-sale-credit" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PharmacySaleCreditUpdate;
